export default "__VITE_ASSET__br9Itc0w__"